import EDC from '../../../shared/globals';

EDC.Animations.Frog = function (scene) {
  this.scene = scene;
  this.frogs = [];
};

EDC.Animations.Frog.prototype.createFrog = function (x, y, isReversed) {
  const sprite = this.scene.add.sprite(x, y, 'frog').setOrigin(0);
  if (isReversed) {
    sprite.setScale(-1, 1);
  }
  this.frogs.push(sprite);
};

EDC.Animations.Frog.prototype.start = function () {
  for (let i = 0; i < this.frogs.length; i++) {
    this.blink(this.frogs[i]);
  }
};

EDC.Animations.Frog.prototype.blink = function (frogSprite) {
  const time = this.getRandomTime();
  this.scene.time.addEvent({
    delay: time,
    callback: function (frog) {
      frog.setFrame(1);
      this.scene.time.addEvent({
        delay: 1000 * 0.5,
        callback: function (frog) {
          frog.setFrame(0);
          this.blink(frog);
        }.bind(this, frog),
        callbackScope: this,
      });
    }.bind(this, frogSprite),
    callbackScope: this,
  });
};

EDC.Animations.Frog.prototype.getRandomTime = function () {
  return 1000 * 2 + Math.round(Math.random() * 20000);
};

export default EDC.Animations.Frog;
